<template lang="pug">
  app-page(title="Статистика Категория-судья")
    app-toolbar(title="Статистика")
      app-toolbar-item-period-short.ml-6(@select="loadPeriod") {{ period ? period.text : 'не выбран' }} 
      app-toolbar-item.ml-2(label="Статистика" :items="tableStat" key-name="title" @select="(item) => item.action()") {{ table.title }}

    .text-right
      v-chip.ma-2(v-if="period " color="#757575" text-color="white" small label close @click:close="period=null") Период: <b>{{ period.text  }}</b>

    v-simple-table(v-if="!loading" v-show="show.category" light fixed-header height="800px")
      template(v-slot:default)
        thead
          tr
            th.border(width="300px") Категория/Судья
            th.px-0.pt-5.text-center.border(v-for="s in stat" :key="s.id") 
              .mt-5
                .rotateText {{ s.lastName.split(" ")[0] }}
              .mt-5.mb-1
                b ({{ s.fullcount }})
        tbody
          tr(v-for="(c, index) in categories" :key="index")
            td.border {{ c.title }} ({{ c.gasCategoryUid }})
            td.text-center.border(v-for="judge in stat" :key="judge.id" v-bind:class="isCategoryJudge(judge, c.id)") 
              span(v-if="findCategory(judge, c.id) > 0")
                b {{ findCategory(judge, c.id) }}
              span(v-else style="color:#959595;") 0
          tr
            td 
              b Общее кол-во дел, из них:
            td.text-right(v-for="s in stat" :key="s.id") 
              b {{ s.fullcount }}
          tr
            td 
              b.ml-6 материалов
            td.text-right(v-for="s in stat" :key="s.id") {{ s.countm }}
          tr
            td 
              b.ml-6 11-х дел
            td.text-right(v-for="s in stat" :key="s.id") {{ s.count11 }}
          tr
            td 
              b.ml-6 13-х дел
            td.text-right(v-for="s in stat" :key="s.id") {{ s.count13 }}
          

    v-simple-table.mt-5(v-if="!loading" v-show="show.group" light fixed-header)
      template(v-slot:default)
        thead(style="height:100px")
          tr
            th(width="300px" style="height:100px;") Группа категорий
            th.px-0.pt-5(v-for="s in stat" :key="s.id" ) 
              .rotateText {{ s.lastName.split(" ")[0] }}
        tbody
          tr(v-for="(g, index) in groups" :key="index" v-bind:class="getClass(g.group_id, g.cat_id)")
            td 
              div(v-if="g.cat_id == 0" @click="showCategory(g.id)") 
                v-icon(v-bind:class="getClassName('group-icon-1-' + g.id, '')") keyboard_arrow_down
                v-icon(v-bind:class="getClassName('group-icon-2-' + g.id, 'hide')") keyboard_arrow_up
                b Группа - {{ g.name }}
              div.pl-5(v-else) {{ g.name }}
            td.text-center(v-for="statJudge in stat" :key="statJudge.id")
              div(v-if="g.cat_id == 0") 
                span(v-if="getCountGroup(g.id, statJudge) > 0")
                  b {{ getCountGroup(g.id, statJudge) }}
                span(v-else style="color:#ccc;") 0
              div(v-else) 
                span(v-if="findCategory(statJudge, g.cat_id) > 0")
                  | {{ findCategory(statJudge, g.cat_id) }}
                span(v-else style="color:#ccc;") 0
            

    app-dialog-loading(v-model="loading")
</template>

<script>
import { distribService, caseService } from "@/_services";
import { mapGetters } from 'vuex';
import { AppDialogConfirm, AppDialogLoading } from '@/components'

import moment from 'moment'
moment.locale('ru')

let tableShow = {
  GROUP: 0,
  CATEGORY: 1,
}

export default {
  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    [AppDialogLoading.name]: AppDialogLoading,
  },

  data () {
    return {
      stat: [],
      category: [],
      groups: [],
      loading: false,
      table: { title: 'По категориям' },
      show: {
        group: false,
        category: true
      },
      today: moment().format('YYYY-MM-DD'),
      period: null,
    }
  },

  mounted () {
    this.loadStat ()
    this.loadGroupCategory()

    this.$store.commit('setInCategory', true)
    this.$store.dispatch('category/INIT')
  },

  computed: {
    ...mapGetters('category', ['categories']),

    tableStat () {
      return [
        { title: 'По категориям', action: () => this.showTable(tableShow.CATEGORY) }, 
        { title: 'По группам',    action: () => this.showTable(tableShow.GROUP) }, 
      ]
    }
  },

  methods: {
    loadPeriod (p) {
      this.period = p
      let sDate = moment(p.start).format("YYYY-MM-DD")
      let eDate = moment(p.end).format("YYYY-MM-DD")
      this.getStatJudgeCategory(sDate, eDate)
    },

    loadStat () {
      let sDate = moment().dayOfYear(1).format("YYYY-MM-DD")
      let eDate = moment().format("YYYY-MM-DD")
      this.getStatJudgeCategory(sDate, eDate)
    },

    getStatJudgeCategory(sDate, eDate) {
      this.loading = true
      distribService.getStatJudgeCategory(sDate, eDate).then(data => {
        this.stat = data.filter(item => item.firstName).sort((a, b) => a.lastName.localeCompare(b.lastName))
        this.category = this.stat[0].distribCategories.sort((a, b) => a.title.localeCompare(b.title))
        this.loading = false
      })
    },

    loadGroupCategory () {
      caseService.listGroupCategory()
      .then(data => {
        data.map(group => {
          this.groups.push({ "name": group.name, "cat_id": 0, "id": group.id })
          group.caseCategory.map(cat => this.groups.push({ "name": cat.title, "cat_id": cat.id, "group_id": group.id }))
        })
      })
    },

    getCountGroup (group_id, judge) {
      let count = 0
      this.groups.map(g => { if (g.group_id == group_id) count += this.findCategory (judge, g.cat_id) })
      return count
    },

    getClass (group_id, category_id) {
      return category_id != 0 ? "hide group-" + group_id : ''
    },

    getClassName (group, hide) {
      return group + ' ' + hide
    },

    showCategory(group_id) {
      var group = document.getElementsByClassName("group-" + group_id);
      for (var i = 0; i < group.length; i++){
        group[i].classList.toggle("hide")
      }

      var groupIcon1 = document.querySelector(".group-icon-1-" + group_id)
      groupIcon1.classList.toggle("hide")

      var groupIcon2 = document.querySelector(".group-icon-2-" + group_id)
      groupIcon2.classList.toggle("hide")
    },

    findCategory (judge, categoryId) {
      let count = 0
      if (judge.distribCategories.length > 0) 
        judge.distribCategories.find(cat => { 
          if (cat.id == categoryId) count  = cat.fullcount
        })
      return count
    },

    isCategoryJudge (judge, categoryId) {
      let isCategory = ""
      if (judge.caseCategories.length > 0) 
        judge.caseCategories.find(cat => { 
          if (cat.id == categoryId) isCategory = "bg-cell-isCategory"
        })
      return isCategory
    },

    showTable (table) {
      if (table == tableShow.GROUP) {
        this.show.group = true
        this.show.category = false
        this.table = {"title": "По группам"}
      } else {
        this.show.group = false
        this.show.category = true
        this.table = {"title": "По категориям"}
      }
      
    }

  }
}
</script>

<style scoped>
.rotateText {
  transform: rotate(-90deg);
  width: 50px;
}

.hide {
  display: none;
}

.bg-cell-isCategory {
  background: #e1f3f5;
  color:#000;
}
.border {
  border: 1px solid #959595;
}
</style>